import { registerSW } from 'virtual:pwa-register';

/**
 * New builds of the web app, without pulling the rug mid-match.
 *
 * With vite-plugin-pwa's autoUpdate, a new service worker reloaded the page the
 * moment it took over -- on the TV that was the whole screen going black in the
 * middle of a game, followed by a second blackout while the display switched
 * back to 50 Hz. Now a waiting update is applied right away only when nothing
 * is being watched, and otherwise on the way back to the overview.
 */

/**
 * The browser only looks for a new service worker on navigation. The TV app
 * is one page that is never reloaded, so without asking now and then it would
 * run the build it was started with for days.
 */
const CHECK_INTERVAL_MS = 10 * 60_000;

let update: ((reload?: boolean) => Promise<void>) | null = null;
let pending = false;
let busy: () => boolean = () => false;

export function initAppUpdates(isWatching: () => boolean): void {
  busy = isWatching;
  update = registerSW({
    onNeedRefresh() {
      pending = true;
      if (!busy()) applyPendingUpdate();
    },
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setInterval(() => {
        if (navigator.onLine) void registration.update().catch(() => {});
      }, CHECK_INTERVAL_MS);
    },
  });
}

/** Reloads into the new build if one is waiting. */
export function applyPendingUpdate(): void {
  if (!pending || !update) return;
  pending = false;
  void update(true);
}
